import linkedinLogo from '../../images/linkedin.png';

function Footer() {
  return (
    <div className="flex justify-center items-center  bg-gradient-to-r from-[#2d2f5b] to-[#31305c] w-screen overflow-x-hidden">
      <div className="text-tertiary flex flex-row m10:flex-col m10:gap-0 m6:gap-10 items-center justify-between m10:justify-end max-w-7xl w-full px-20 mt-16 py-10">
        <div className="flex flex-row items-center gap-14 m10:flex-col m10:gap-6 m10:items-start m6:items-center m10:w-full">
          <a href='https://www.linkedin.com/company/snow-gmao/' className="duration-75 hover:opacity-70">
            <img src={linkedinLogo} className="h-10" alt="linkedin" />
          </a>
          <a href='/mentions' className=" duration-75 hover:opacity-70 text-center">Mentions légales</a>
          <a href='/conditions' className="duration-75 hover:opacity-70 text-center">Conditions d'utilisation</a>
          <a href={`${window.location.href}#`} className="duration-75 hover:opacity-70 text-2xl" title="Go on top">
          ⇧
          </a>
        </div>
        <p className=" m10:w-full m10:text-right m6:text-center">
          © 2022 - 2024 Snow GMAO. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;